// 订单模块国际化 - 中文
export default {
  // 模式切换
  modes: {
    business: '业务',
    tracking: '运踪',
    warehouse: '仓库'
  },

  // 加载提示
  loading: {
    trackingInfo: '加载运踪信息中...',
    businessNodes: '正在加载业务节点...'
  },

  // 错误提示
  error: {
    loadTrackingFailed: '获取运踪信息失败',
    loadBusinessStatusFailed: '加载业务状态失败'
  },

  // 业务节点（SOP）
  businessNodes: {
    remark: '备注：',
    empty: '暂无业务节点',
    legend: {
      done: '已完成',
      doing: '进行中',
      warn: '异常',
      wait: '未开始'
    }
  },

  // 运踪节点
  trackingNodes: {
    // 状态说明
    legend: {
      manual: '手动数据',
      thirdParty: '第三方数据',
      pending: '未完成'
    },

    // 节点信息
    info: {
      quantity: '箱量',
      plannedBerth: '计划靠泊',
      plannedUnberth: '计划离泊'
    }
  }
}
